import React from 'react';
import PropTypes from 'prop-types';

const TitleMain = props => {
  return (
    <section className={`main_title_new`}>
      <h1>{props.language.detail_fatigue.nfa.evoulutionRisk}</h1>
    </section>
  );
};

export default TitleMain;



// WEBPACK FOOTER //
// ./source/client/components/driver_nfa/title.jsx